import React, {useCallback, useState} from "react";
import * as THREE from "three";
import {store} from "../../../../../Store/index.js";
import {GetTinyTransparentImageTexture, tinyTransparentImageAsBase64Str, useBase64ImageStrAsTexture} from "../../../../../Utils/ThreeJS/3JSHooks.js";
import {observer_mgl_r3} from "../../../../../Utils/ThreeJS/General.js";

export const MemoryPalaceSnapshotUI_count = 3;
export const MemoryPalaceSnapshotUI = observer_mgl_r3((props: {mainTexWToHRatio: number, snapshotImageData: string, index: number})=>{
	const {mainTexWToHRatio, snapshotImageData, index} = props;
	const vrState = store.main.tools.vr;

	const [texWToHRatio, setTexWToHRatio] = useState(16/9);

	// Calculate positioning for memory palace frames (vertically stacked to the left of main frame)
	const smallFrameScale = 0.3;
	const spacingBetweenFrames = 0.05;
	//const mainFrameLeftEdge = -texWToHRatio / 2;
	const mainFrameLeftEdge = -mainTexWToHRatio / 2;
	const distanceFromMainFrame = 0.1;
	const smallFrameWidth = texWToHRatio * smallFrameScale;
	const smallFrameHeight = 1 * smallFrameScale;
	const xOffset = mainFrameLeftEdge - distanceFromMainFrame - (smallFrameWidth / 2);
	// Stack vertically: start from top and go downward
	const yOffset = (MemoryPalaceSnapshotUI_count - 2 - index) * (smallFrameHeight + spacingBetweenFrames);

	// Calculate scale to fit the snapshot image within the assigned zone
	// The assigned zone has dimensions: smallFrameWidth x smallFrameHeight
	// The snapshot has aspect ratio: snapshotTextureWidthRelToHeight : 1
	const maxWidth = smallFrameWidth / smallFrameScale; // Normalize to pre-scale dimensions
	const maxHeight = smallFrameHeight / smallFrameScale;

	// Determine which dimension is the limiting factor
	const scaleByWidth = maxWidth / texWToHRatio;
	const scaleByHeight = maxHeight / 1;
	const fitScale = Math.min(scaleByWidth, scaleByHeight) * smallFrameScale;

	const snapshotImageAsTexture = useBase64ImageStrAsTexture(snapshotImageData ?? tinyTransparentImageAsBase64Str, GetTinyTransparentImageTexture().image, useCallback((img: HTMLImageElement)=>{
		if (img.src != tinyTransparentImageAsBase64Str) {
			setTexWToHRatio(img.width / img.height);

			// Apply blur filter to the first snapshot (index 0)
			if (index == 0) {
				// Create a canvas to apply blur
				const canvas = document.createElement("canvas");
				const ctx = canvas.getContext("2d")!;
				canvas.width = img.width;
				canvas.height = img.height;

				// Apply heavy blur
				const blurSize_abs = store.main.settings.vr.memoryPalaceSnapshotBlurSize * img.width;
				ctx.filter = `blur(${Math.round(blurSize_abs)}px)`;
				ctx.drawImage(img, 0, 0);

				// Create and store blurred texture
				const newBlurredTexture = new THREE.CanvasTexture(canvas);
				newBlurredTexture.colorSpace = THREE.SRGBColorSpace;
				setBlurredTexture(newBlurredTexture);
			}
		}
	}, [index]));

	const [blurredTexture, setBlurredTexture] = useState<THREE.Texture | null>(null);

	return (
		<mesh position={[xOffset, yOffset, 0]} scale={[fitScale, fitScale, fitScale]}>
			<planeGeometry args={[texWToHRatio, 1]} />
			<meshBasicMaterial map={index == 0 && vrState.snapshotRevealLevel <= 0 ? (blurredTexture ?? GetTinyTransparentImageTexture()) : snapshotImageAsTexture} />
		</mesh>
	);
});